import {createUseStyles} from 'react-jss';

/**
 * Global styles are not a default solution
 * - you should consult with team before adding any styles here
 */
export default createUseStyles({
  '@global': {
    select: {
      backgroundRepeat: 'no-repeat',
      backgroundSize: 12,
      backgroundPosition: 'right 10px center',
    },
    '.m-unit-1': {
      float: 'left',
      marginRight: '1em',
    },
    '.no-scroll': {
      overflow: 'hidden',
    },
  },
});
